export function Logo({ className = "h-8 w-8", full = false }: { className?: string; full?: boolean }) {
  return (
    <img
      src={full ? "/logo-full.svg" : "/logo-icon.svg"}
      alt={full ? "RentOS" : ""}
      aria-hidden={full ? undefined : true}
      width={full ? 280 : 40}
      height={full ? 100 : 40}
      className={`rentos-brand object-contain ${className}`}
    />
  );
}
